import { findOne } from 'rcd-cpp-workspace/utils/array';
import * as React from 'react';
import { FilterProps } from '../filters';
import { Op } from '../../../enums/Op';
import { getSearchReferenceAPI, parseCondition } from '../../../utils';
import { ReferenceSearch } from '../../ReferenceSearch/referenceSearch';
import { Metadata } from '../../../types/Metadata';
import { Options } from '../Options/options';

const SearchOpts = [Op.is, Op.isNot];
const InputOpts = [Op.contains, Op.doesNotContain, Op.startsWith, Op.endsWith];
const isSameType = (op1: Op, op2: Op) => {
  if (SearchOpts.includes(op1) && SearchOpts.includes(op2)) {
    return true;
  }
  if (InputOpts.includes(op1) && InputOpts.includes(op2)) {
    return true;
  }
  return false;
};

export const ComputedFilter = ({
  filter,
  field,
  setFilter,
  cache,
  filters
}: FilterProps) => {
  const curFilter = filter; //findOne(filters, { field: filter.field });
  const api = getSearchReferenceAPI(field);
  const options = api ? SearchOpts : InputOpts;
  const { op, val } = parseCondition(curFilter.conditions, options[0]);

  return (
    <div className="filter-box reference-filter tree-filter">
      <div>
        {field.name}&nbsp;
        <Options
          options={options}
          onSelect={o => {
            if (isSameType(op, o)) {
              setFilter({ ...curFilter, conditions: [{ [o]: val }] });
            } else {
              setFilter({ ...curFilter, conditions: [{ [o]: null }] });
            }
          }}
          selected={op}
        />
      </div>
      <div>
        {InputOpts.includes(op) && (
          <input
            type="text"
            className="form-control"
            value={val}
            onChange={(e: any) => {
              setFilter(
                { ...curFilter, conditions: [{ [op]: e.target.value }] },
                true
              );
            }}
          />
        )}
        {SearchOpts.includes(op) && (
          <ReferenceSearch<Metadata>
            inlineMenu={true}
            minLength={0}
            maxResults={50}
            open={true}
            cache={cache}
            multiple
            field={field.key}
            selected={val}
            api={api}
            hideIcon={true}
            onChange={values => {
              setFilter(
                { ...curFilter, conditions: [{ [op]: values.map(v => v.id) }] },
                true
              );
            }}
          />
        )}
      </div>
    </div>
  );
};
